/**
 * jquery.elementDirectionAndOffsetByScroll
 * --
 * Version: 0.0.1
 * Copyright: Kolja Kutschera(koljakutschera.de)
 * License: MIT
 * Browsersupport: IE9+
 * Usage example: $('.fixed-header').elementDirectionAndOffsetByScroll('init', {});
 */
(function ($) {

    function manageClassByScrollDirection (lastScrollDirection) {

        if(lastScrollDirection !== this.data('elementDirectionAndOffsetByScroll').state.scrollDirection){

            if(this.data('elementDirectionAndOffsetByScroll').state.scrollDirection === 'down'){

                this.addClass(this.data('elementDirectionAndOffsetByScroll').options.classScrollDirectionDown);
                this.removeClass(this.data('elementDirectionAndOffsetByScroll').options.classScrollDirectionUp);
            } else {

                this.addClass(this.data('elementDirectionAndOffsetByScroll').options.classScrollDirectionUp);
                this.removeClass(this.data('elementDirectionAndOffsetByScroll').options.classScrollDirectionDown);
            }

            if(this.data('elementDirectionAndOffsetByScroll').options.callbackScrollDirection){

                if(typeof this.data('elementDirectionAndOffsetByScroll').options.callbackScrollDirection === 'function'){

                    this.data('elementDirectionAndOffsetByScroll').options.callbackScrollDirection.call(this,
                        this.data('elementDirectionAndOffsetByScroll').state.scrollDirection
                    )
                }
            }
        }

        return this;
    }

    function manageClassByOffset (lastscrollOffsetSmall, lastscrollOffsetOut) {

        if(lastscrollOffsetSmall !== this.data('elementDirectionAndOffsetByScroll').state.scrollOffsetSmall){

            if(this.data('elementDirectionAndOffsetByScroll').state.scrollOffsetSmall){

                this.addClass(this.data('elementDirectionAndOffsetByScroll').options.classOffsetSmall);
            } else {

                this.removeClass(this.data('elementDirectionAndOffsetByScroll').options.classOffsetSmall);
            }

            if(this.data('elementDirectionAndOffsetByScroll').options.callbackOffsetSmall){

                if(typeof this.data('elementDirectionAndOffsetByScroll').options.callbackOffsetSmall === 'function'){

                    this.data('elementDirectionAndOffsetByScroll').options.callbackOffsetSmall.call(this,
                        this.data('elementDirectionAndOffsetByScroll').state.scrollOffsetSmall
                    )
                }
            }
        }

        if(lastscrollOffsetOut !== this.data('elementDirectionAndOffsetByScroll').state.scrollOffsetOut){

            if(this.data('elementDirectionAndOffsetByScroll').state.scrollOffsetOut){

                this.addClass(this.data('elementDirectionAndOffsetByScroll').options.classOffsetOut);
            } else {

                this.removeClass(this.data('elementDirectionAndOffsetByScroll').options.classOffsetOut);
            }

            if(this.data('elementDirectionAndOffsetByScroll').options.callbackOffsetOut){

                if(typeof this.data('elementDirectionAndOffsetByScroll').options.callbackOffsetOut === 'function'){

                    this.data('elementDirectionAndOffsetByScroll').options.callbackOffsetOut.call(this,
                        this.data('elementDirectionAndOffsetByScroll').state.scrollOffsetOut
                    )
                }
            }
        }

        return this;
    }

    function manageScroll (scrollTop) {
        
        var lastScrollTop =  this.data('elementDirectionAndOffsetByScroll').state.scrollTop;
        var lastScrollDirection = this.data('elementDirectionAndOffsetByScroll').state.scrollDirection;
        var lastscrollOffsetSmall = this.data('elementDirectionAndOffsetByScroll').state.scrollOffsetSmall;
        var lastscrollOffsetOut =  this.data('elementDirectionAndOffsetByScroll').state.scrollOffsetOut;

        if(lastScrollTop !== scrollTop){

            this.data('elementDirectionAndOffsetByScroll').state.scrollTop = scrollTop;

            if(scrollTop > lastScrollTop){

                this.data('elementDirectionAndOffsetByScroll').state.scrollDirection = 'down';
                this.data('elementDirectionAndOffsetByScroll').state.scrollDifference = scrollTop - lastScrollTop;
            } else {

                this.data('elementDirectionAndOffsetByScroll').state.scrollDirection = 'up';
                this.data('elementDirectionAndOffsetByScroll').state.scrollDifference = lastScrollTop - scrollTop;
            }

            manageClassByScrollDirection.call(this, lastScrollDirection)
        }

        if(scrollTop > this.data('elementDirectionAndOffsetByScroll').options.offsetSmall){

            this.data('elementDirectionAndOffsetByScroll').state.scrollOffsetSmall = true;
        } else {

            this.data('elementDirectionAndOffsetByScroll').state.scrollOffsetSmall = false;
        }

        if(scrollTop > this.data('elementDirectionAndOffsetByScroll').options.offsetOut){

            this.data('elementDirectionAndOffsetByScroll').state.scrollOffsetOut = true;
        } else {

            this.data('elementDirectionAndOffsetByScroll').state.scrollOffsetOut = false;
        }

        manageClassByOffset.call(this, lastscrollOffsetSmall, lastscrollOffsetOut);

        //this.attr('data-scrolltop', scrollTop); // Waiting for https://developer.mozilla.org/de/docs/Web/CSS/attr not content only support

        return this;
    }

    function init (options) {

        this.data('elementDirectionAndOffsetByScroll', {
            options : $.extend({
                offsetSmall: 0,
                offsetOut: 0,
                container : $(document),
                classInit : 'element-direction-and-offset-by-scroll',
                classScrollDirectionDown : 'scroll-direction-is-down',
                classScrollDirectionUp : 'scroll-direction-is-up',
                classOffsetSmall: 'scroll-offset-small-is-reached',
                classOffsetOut : 'scroll-offset-out-is-reached',
                callbackScrollDirection : null /*function (scrollDirection) {
                    console.log(scrollDirection)
                    console.log(this)
                } */,
                callbackOffsetSmall : null/* function (scrollOffsetSmall) {
                    console.log(scrollOffsetSmall)
                    console.log(this)
                } */
            }, options)
        });
        

        this.data('elementDirectionAndOffsetByScroll').state = {
            scrollTop : this.data('elementDirectionAndOffsetByScroll').options.container.scrollTop(),
            scrollDirection : null,
            scrollDifference : null,
            scrollOffsetSmall: null,
            scrollOffsetOut : null
        }

        manageScroll.call(this, this.data('elementDirectionAndOffsetByScroll').options.container.scrollTop());

        this.addClass(this.data('elementDirectionAndOffsetByScroll').options.classInit);

        this.data('elementDirectionAndOffsetByScroll').options.container.on('scroll.elementDirectionAndOffsetByScroll', $.proxy(function(event) {

             manageScroll.call(this, $(event.target).scrollTop());
        },this));

        return this;
    }

    function destroy () {

        this.data('elementDirectionAndOffsetByScroll').options.container.off('scroll.elementDirectionAndOffsetByScroll');

        this.data('elementDirectionAndOffsetByScroll', null);
        
        this.removeClass(this.data('elementDirectionAndOffsetByScroll').options.classScrollDirectionDown);
        this.removeClass(this.data('elementDirectionAndOffsetByScroll').options.classScrollDirectionUp);
        this.removeClass(this.data('elementDirectionAndOffsetByScroll').options.classOffsetSmall);
        this.removeClass(this.data('elementDirectionAndOffsetByScroll').options.classInit);

        return this;
    }
 
    $.fn.elementDirectionAndOffsetByScroll = function(action, options) {

        switch (action) {
            case 'init':
                init.call(this, options)
                break;
            case 'destroy':
                destroy.call(this, options)
                break;
            default:
                init.call(this, options)
        }

        return this;
    };
}(jQuery));